export class SapConfig {
    static readonly localSap = '1ASIULSARFDD';
    static readonly localLoginPhase = 'dev';
    static readonly usap = {
      DEFAULT_OFF: '1ASIUSASOFF',
      DEFAULT_TPA: '1ASIURFDTPAWS'
    };
  
    static readonly phaseLetter: { [key: string]: string } = {
      DEV: 'D',
      DES: 'S',
      UAT: 'U',
      USR: 'D',
      PDT: '',
      PRD: '',
      PPT: '',
      MIG: 'M',
      SKL: 'K',
      BTPRD: 'R',
      INT: 'I',
      QRT: 'Q',
      FVT: 'F',
      SUP: 'T',
      AP1: 'A'
    };
  
    static getPhaseLetter(phase: string): string {
      return SapConfig.phaseLetter[phase.toUpperCase()] || '';
    }
  }
